import "./JoinUs.module.css";
import Header from "@/reusable_sections/Header";
import FindTheGarden from "./sections/FindTheGarden";
import PlotRentalInquiry from "./sections/PlotRentalInquiry";
import Footer from "@/reusable_sections/Footer";
export default function JoinUsPage() {
  return <div>
      <Header />
      <FindTheGarden />
      <PlotRentalInquiry />
      <Footer />
    </div>;
}